import { createFileRoute, notFound } from "@tanstack/react-router";

// Authed catch-all: unmatched paths land here (login and the /api/* server
// routes are more specific and win). This keeps unknown URLs fail-closed the
// way the old root-level gate did — an unauthenticated visitor is sent to
// login with the original href preserved (deep links to not-yet-ported pages
// get a sign-in round trip instead of a public 404), and probes can't
// distinguish protected paths from nonexistent ones.
export const Route = createFileRoute("/_authed/$")({
  // A dead-end tab still names itself — without this the 404 inherits the
  // product-name default and can't be told from any other page in history.
  head: () => ({ meta: [{ title: "Page not found" }] }),
  loader: () => {
    throw notFound();
  },
});
